// CarItem.tsx
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { MultiCarItem } from "../../home/components/types";

interface CarItemProps {
  car: MultiCarItem;
  index: number;
  isEditing: boolean;
  isActiveEdit: boolean;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
  onDeleteProduct: (product: MultiCarItem["productDetails"][number], carIndex: number) => void;
}

const CarItem: React.FC<CarItemProps> = ({ car, index, isEditing, isActiveEdit, onEdit, onDelete, onDeleteProduct }) => {
  const isHighlighted = isEditing && isActiveEdit;

  return (
    <div className={`border rounded-xl p-4 bg-white shadow-sm ${isHighlighted ? "border-green-500 ring-2 ring-green-500 ring-opacity-50" : "border-gray-200"}`}>
      {/* Header */}
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <h4 className="font-bold text-gray-900 text-lg">{car.carNumber}</h4>
          <button onClick={() => onEdit(index)} className="text-blue-600 transition-colors duration-200" aria-label="Edit Car">
            <EditIcon fontSize="small" />
          </button>
        </div>
        <button onClick={() => onDelete(index)} className="text-red-500 transition-colors duration-200" aria-label="Delete Car">
          <DeleteIcon fontSize="small" />
        </button>
      </div>

      {/* Product List */}
      <div className="space-y-2">
        {car.productDetails.map((product, i) => (
          <div key={product._id?.$oid ?? `${product.productName}-${i}`} className="flex justify-between items-center py-2">
            <div className="flex-1">
              <p className="text-gray-800 font-medium">{product.productName}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-gray-900 font-semibold">{product.amount}</span>
              <button onClick={() => onDeleteProduct(product, index)} className="text-red-500 hover:text-red-700 transition-colors duration-200" aria-label="Delete Product">
                <DeleteIcon fontSize="small" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Subtotal */}
      <div className="flex justify-between items-center mt-3 pt-3 border-t border-gray-100">
        <span className="text-gray-600 font-medium">Subtotal</span>
        <span className="text-gray-900 font-bold text-lg">{(car.totalPrice ?? 0).toFixed(2)}</span>
      </div>
    </div>
  );
};

export default CarItem;
